import {routes} from './indicadores.routes';
import IndicadoresService from "./indicadores.service";
import IndicadoresDetailsController from "./details/details.controller";

export default angular.module('app.indicadores', [])
  .config(routes)
  .service('IndicadoresService', IndicadoresService)
  .controller('IndicadoresDetailsController', IndicadoresDetailsController)
  .name;
